<template>
  <div>
    <div class="clerk-payout-area" v-if="!Array.isArray(bets.bets)">
      <div class="clerk-payout-area-title">
        {{ $t('ClerkPayout.Sportsbook') }}
      </div>
      <div class="clerk-payout-area-content" :key="index" v-for="(bet, key, index) in bets.bets">
        <div class="col-md-12 d-flex row">
          <template v-for="innerBet in bet">
            <div :key="innerBet.id" class="col-md-6 p-2">
              <div class="clerk-payout-area-content-inner col-md-12" style="height: 300px">
                <div class="clerk-payout-area-content-title">
                  {{ innerBet.description }}
                </div>
                <div
                  class="clerk-payout-area-content-detail"
                  :key="index + '_detail'"
                  v-for="(detail, index) in innerBet.bet.wager_header.wager_details"
                >
                  <span
                    class="span-wager-detail"
                    v-html="detail.detail_description_c.replace(/~~/g, ' ') + ' ' + getOdd(detail)"
                  ></span>
                </div>
                <div class="clerk-payout-area-content-amounts">
                  <div>
                    <strong>{{ $t('Risk') }}: </strong>
                    <span>{{ parseFloat(innerBet.risk).toFixed(2) }}</span>
                  </div>
                  <div>
                    <strong>{{ $t('Win') }}: </strong>
                    <span>{{ parseFloat(innerBet.win).toFixed(2) }}</span>
                  </div>
                  <div v-if="getAmount(innerBet.tax_amount)">
                    <strong>{{ $t('Tax') }}: </strong>
                    <span>{{ getAmount(innerBet.tax_amount) }} </span>
                  </div>
                  <div v-if="getAmount(innerBet.pay_amount)">
                    <strong>{{ $t('Pay Amount') }}: </strong>
                    <span>{{ getAmount(innerBet.pay_amount) }}</span>
                  </div>
                </div>
                <div
                  v-if="innerBet.is_payable && allow_partial_bet_payout && selectButtonVisible(bet)"
                  class="clerk-payout-area-content-select mt-3 d-flex justify-content-end"
                >
                  <button
                    class="btn btn-outline green"
                    v-if="!selectedBets.find((item) => item === innerBet.id)"
                    @click="selectedBets.push(innerBet.id)"
                  >
                    {{ $t('ClerkPayout.Add') }}
                  </button>
                  <button
                    class="btn btn-outline red"
                    v-else
                    @click="selectedBets = selectedBets.filter((item) => item !== innerBet.id)"
                  >
                    {{ $t('ClerkPayout.Remove') }}
                  </button>
                </div>
                <div
                  class="clerk-payout-area-content-inner-result"
                  :class="[
                    {
                      win: innerBet.result === 'WIN',
                      loss: innerBet.result === 'LOSS',
                    },
                  ]"
                >
                  {{ $t(innerBet.result) }}
                </div>
              </div>
            </div>
          </template>
          <div v-if="isMobileScanCode" class="d-flex justify-content-end align-items-end p-2 col-md-6">
            <button
              :disabled="
                !!payoutStatus.loading || !selectedBetsCond.length || disableConfirmButtonForMobileScanCode(bet)
              "
              class="btn btn-green"
              @click="isSportsbook ? createDeposit() : createTicket()"
            >
              {{ $t('ClerkPayout.Confirm') }} <i v-if="payoutStatus.loading" class="fa fa-spinner fa-spin"></i>
            </button>
          </div>
        </div>
        <!--
        <div
          v-if="bet.some(item => item.is_payable) && !allow_partial_bet_payout"
          style="grid-row: 3"
          class="clerk-payout-area-content-select mt-3 d-flex justify-content-end"
        >
          <button
            class="btn btn-outline green"
            v-if="!selectedBets.find(item => bet.map(innerItem => innerItem.id).includes(item))"
            @click="selectedBets = [...selectedBets, ...bet.filter(item => item.is_payable).map(item => item.id)]"
          >
            {{ $t('ClerkPayout.Add') }}
          </button>
          <button
            class="btn btn-outline red"
            v-else
            @click="selectedBets = selectedBets.filter(item => !bet.map(innerItem => innerItem.id).includes(item))"
          >
            {{ $t('ClerkPayout.Remove') }}
          </button>
        </div>
        -->
      </div>
      <slot></slot>
    </div>
    <div v-if="!isMobileScanCode" class="d-flex justify-content-end mt-3 history-bets-table-bottom">
      <button
        :disabled="!!payoutStatus.loading || !selectedBetsCond.length"
        class="btn btn-green"
        @click="isSportsbook ? createDeposit() : createTicket()"
      >
        {{ $t('ClerkPayout.Confirm') }} <i v-if="payoutStatus.loading" class="fa fa-spinner fa-spin"></i>
      </button>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/shared/DataTable';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import { normalizeDetail } from './history-utils';
import snq from 'snq';
import { flatten } from '@/utils/common';
import { extractError } from '@/utils/errorUtil';
import { roundAmount, americanToDecimal, fractionFromUS } from '@/views/sports/components/bet-slip/bet-slip-utils';
import { printDepositTicket, printWagerTicket } from '@/plugins/printFactory';
import Vue from 'vue';
import { openErrorModal } from '@/utils/modalHelper';
import { isElectronContext } from '../../utils/isElectron';
import { ExternalWagerLoginTypes, LoginTypes } from '../../utils/enums';
import { _api } from '../../utils/apiAxios';
export default {
  components: {
    DataTable,
  },
  data() {
    return {
      selectedBets: [],
      payoutStatus: {
        loading: '',
      },
    };
  },
  props: ['bets', 'showGradedColumn', 'isSportsbook'],
  beforeUpdate() {
    if (this.allow_partial_bet_payout && this.bets) {
      Object.values(this.bets.bets).forEach((bet) => {
        const winnerBets = bet.filter((bet) => bet.result === 'WIN' || bet.result === 'PUSH');
        if (winnerBets.length === 1) {
          winnerBets.forEach((bet) => {
            this.selectedBets.push(bet.id);
          });
        }
      });
    }

    console.log(this.bets);
  },
  mounted() {
    if (!this.isSportsbook) {
      this.setTicketAllBets({
        bets: [],
        horse_bets: [],
      });
    }
    this.setBalanceResponse({});
  },
  computed: {
    ...mapGetters('clerkPayoutDepositTicketStore', ['betsFields']),
    ...mapGetters('player', ['currencySymbol']),
    ...mapState({
      scanCode: (state) => state.clerkPayoutDepositTicketStore.scanCode,
      terminalInfo: (state) => state.settings.terminalInfo,
      selectedOddType: (state) => state.settings.selectedOddType,
      isMobileScanCode: state => state.clerkPayoutDepositTicketStore.isMobileScanCode,
    }),
    allow_partial_bet_payout() {
      return this.terminalInfo.location.allow_partial_bet_payout;
    },
    selectedBetsCond() {
      if (!this.allow_partial_bet_payout && this.bets) {
        return flatten(
          snq(() => Object.values(this.bets.bets), []).map((bet) => {
            return [...bet.filter((item) => item.is_payable).map((item) => item.id)];
          }, []),
        );
      } else {
        return this.selectedBets;
      }
    },
  },
  methods: {
    ...mapActions('depositTicketStore', ['tryScanBarcode']),
    ...mapActions('clerkPayoutDepositTicketStore', ['tryScanCode']),
    ...mapMutations({
      setBetsConfirmationModal: 'depositTicketStore/setBetsConfirmationModal',
      setSportsBookPayoutSuccessModal: 'depositTicketStore/setSportsBookPayoutSuccessModal',
      addCalc: 'depositTicketStore/addCalc',
    }),
    ...mapMutations('clerkDepositStore', ['setPrinterStatus']),
    ...mapMutations('clerkPayoutDepositTicketStore', ['setTicketAllBets', 'setBalanceResponse']),
    normalizeDetail,
    getOdd(val) {
      var odd;
      if (val.Odd) odd = val.Odd;
      else if (val.odd) odd = val.odd;
      if (this.selectedOddType == 'D') {
        return roundAmount(americanToDecimal(odd));
      } else if (this.selectedOddType == 'E') {
        return val > 0 ? `+${odd}` : odd;
      } else {
        return fractionFromUS(odd);
      }
    },
    getAmount(val) {
      return val ? parseFloat(val).toFixed(2) : false;
    },
    selectButtonVisible(bets) {
      const winnerBets = bets.filter((bet) => bet.result === 'WIN');
      return winnerBets.length > 1;
    },
    createTicket() {
      const self = this;
      if (this.selectedBetsCond.length) {
        let payload = {
          scan_code: this.scanCode,
          bet_ids: this.selectedBetsCond.map((item) => parseInt(item)),
          horse_bet_ids: [],
          balance_amount: 0,
          description: 'CLERK_PAYOUT',
          reference: 'CLERK_PAYOUT',
          terminal_id: this.terminalInfo.terminal_id,
        };
        this.payoutStatus.loading = true;

        this.$api
          .post('/clerk/makepayout', payload)
          .then((res) => {
            this.payoutStatus.message = '';

            if (res.data.IsSuccess) {
              const innerData = res.data.Data.data;

              self.$modal.openSuccessModal({
                title: 'ClerkPayout.PayoutSuccess',
                content:
                  this.$t('ClerkPayout.TotalAmount') +
                  ': ' +
                  snq(() => parseFloat(innerData.payout.total_amount).toFixed(2)),
              });

              this.addCalc({
                type: 'bet',
                ticketNumber: res.data.Data.data.payout.main_ticket_id,
                amount: -res.data.Data.data.payout.total_amount,
                minus: true,
              });

              const ticketJson = {
                barcode: innerData.ticket.scan_code,
                bets: innerData.ticket.ticket_detail.bets,
                currency: this.$store.state.settings.terminalInfo.currency_name,
                paid: innerData.payout.total_amount,
                isPaid: true,
              };

              printWagerTicket({
                clientType: this.$store.state.settings.clientType,
                ticketJson,
                lang: this.$store.state.settings.selectedLocale.code,
                callback: function () {
                  self.setPrinterStatus({ success: true });
                },
                isNewResponse: true,
                reprintTicket: innerData.ticket.ticket_detail,
                hideBarcode: true,
              });

              this.tryScanCode();
            } else {
              openErrorModal({
                content: extractError(res) || 'ClerkPayout.PayoutError',
              });
            }
          })
          .catch(() => {
            openErrorModal({
              content: 'ClerkPayout.PayoutError',
            });
          })
          .finally(() => {
            this.payoutStatus.loading = false;
          });
      }
    },
    createDeposit() {
      this.payoutStatus.loading = true;

      this.tryScanBarcode({
        scan_code: this.scanCode,
        horse_bet_ids: [],
        bet_ids: this.selectedBetsCond.map((item) => parseInt(item)),
      }).then((response) => {
        if (!response.data.IsSuccess) {
          this.$modal.openErrorModal({ title: extractError(response) || 'SportsBookPayout.PayoutError' });
          return;
        }

        if (response.data.IsSuccess) {
          this.setBetsConfirmationModal(false);
          this.setSportsBookPayoutSuccessModal(true);
        }

        if (isElectronContext() && this.$store.state.settings.terminalInfo.can_clerk_login !== '1') {
          // let isDefault = 0 //terminalInfo.active_wallet ? terminalInfo.active_wallet.RetainValueWhenScanned : 1
          this.$store.commit('settings/setIsBalanceLoading', true);
          _api
            .post('/terminal/getactivebalance', {
              mac_address: this.$store.state.settings.macAddress,
            })
            .then((r) => {
              if (r.data.IsSuccess) {
                const remaining_balance = r.data.Data.data;
                this.$store.commit(
                  'depositTicketStore/setIsDefaultDepositFlow',
                  !remaining_balance || !remaining_balance.ticket_number,
                  { root: true },
                );
                if (remaining_balance && remaining_balance.ticket_number) {
                  this.$store.commit(
                    'player/setLoginType',
                    LoginTypes.Clerk == this.$store.state.player.loginType
                      ? ExternalWagerLoginTypes.ClerkDepositTicket
                      : ExternalWagerLoginTypes.DepositTicket,
                    { root: true },
                  );

                  const available_balance = snq(() => remaining_balance.available_balance);

                  if (parseFloat(available_balance) > 0) {
                    this.$store.commit('depositTicketStore/setScanCode', remaining_balance.scan_code, { root: true });
                    this.$store.commit(
                      'depositTicketStore/setBalanceResponse',
                      { ...remaining_balance, scan_type: 'D' },
                      { root: true },
                    );
                  }
                }
              }
              this.$store.commit('settings/setIsBalanceLoading', false);
            });
        }

        this.payoutStatus.loading = false;
      });
    },
    disableConfirmButtonForMobileScanCode(bet) {
      const resultArray = bet.map((item) => item.result);
      return !resultArray.includes("WIN")
    }
  },
};
</script>

<style lang="scss">
.span-wager-detail {
  float: left;
  width: 100%;
}

.clerk-payout-area {
  padding: 16px;
  border-radius: 4px;
  background-color: white;
  max-height: 50vh;
  overflow-y: auto;

  &-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 16px;
  }
  &-content {
    padding: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    &-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
      grid-gap: 16px;
    }
    &-title {
      font-size: 14px;
      font-weight: bold;
    }
    &-inner {
      position: relative;
      padding: 16px;
      border: 1px solid #ccc;
      border-radius: 4px;
      &-result {
        font-size: 10px;
        font-weight: bold;
        background-color: #ccc;
        padding: 4px;
        border-radius: 3px;
        position: absolute;
        top: -12px;
        right: -8px;
        &.win {
          background-color: green;
          color: white;
        }
        &.loss {
          background-color: red;
          color: white;
        }
      }
    }
  }
}
</style>
